import SiteChrome from "@chrome/SiteChrome";
import { SiteHtmlPageTitle } from "@content/en/HtmlTitle";
import WebinarListPage from "@components/webinars/WebinarListPage";
import { MetaDescription } from "@components/MetaDescription";
import { HtmlPageTitle } from "@components/HtmlPageTitle";

const WebinarsLandingPage = () => (
  <SiteChrome>
    <HtmlPageTitle title={`Webinars - ${SiteHtmlPageTitle}`} />
    <MetaDescription description="Listing of upcoming and past Blues webinars. Join us live to ask questions and get involved!" />

    <WebinarListPage />
  </SiteChrome>
);

export default WebinarsLandingPage;
